// @flow
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useRegisterFocusArea } from "../focus-area";

import {
  getAtivoExcel,
  getModoDeBuscaDoAtivoExcel,
  editarAtivoExcel,
  editarModoBuscaDoAtivoExcel,
} from "../../state";

import RadioGroup from "../comum/RadioGroup";

import "./ativo.css";

const modosDeBusca = [
  { id: "ATIVO", nome: "Ativo" },
  { id: "GRUPO", nome: "Grupo / Busca Avançada" },
];

export const AtivoInput = () => {
  const dispatch = useDispatch();
  const ativo = useSelector(getAtivoExcel);
  const onEditar = useCallback(
    event => dispatch(editarAtivoExcel(event.target.value)),
    [dispatch]
  );
  const registerInputRef = useRegisterFocusArea("inputAtivo");

  const modoDeBusca = useSelector(getModoDeBuscaDoAtivoExcel);
  const onMudarModoDeBusca = useCallback(
    event => {
      const value = event.target.value;
      if (value === "ATIVO" || value === "GRUPO") {
        dispatch(editarModoBuscaDoAtivoExcel(value));
      }
    },
    [dispatch]
  );

  return (
    <div className="AtivoInput__container">
      <h3 className="AtivoInput__title">Selecionar Ativos</h3>

      <div className="AtivoInput__modos">
        <RadioGroup
          nome="modosDeBuscaExcel"
          itens={modosDeBusca}
          campoId="id"
          campoDescricao="nome"
          onChange={onMudarModoDeBusca}
          itemSelecionado={modoDeBusca}
        />
      </div>

      <input
        className="AtivoInput__input"
        id="ativoExcel"
        type="text"
        placeholder="Insira o nome do ativo (conforme aparece no sistema), código de referência, ISIN, CNPJ, Ticker, ou faça referência à uma célula."
        value={ativo}
        onChange={onEditar}
        ref={registerInputRef}
      />
    </div>
  );
};
